import { render, staticRenderFns } from "./ElasticAiChatConversations.vue?vue&type=template&id=61b223bb&scoped=true"
import script from "./ElasticAiChatConversations.vue?vue&type=script&setup=true&lang=js"
export * from "./ElasticAiChatConversations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b223bb",
  null
  
)

export default component.exports